import collections from "@api/collections";
import CommentsButton from "@buttons/CommentsButton";
import { handleDownload } from "@helpers/downloads";
import DataGrid from "@shared/DataGrid";
import DetailsButton from "@shared/DetailsButton";
import React from "react";
import { Button, Dropdown, Grid, Icon } from "semantic-ui-react";
import CollectionFilters from "./CollectionFilters";

class BaseCollection extends React.Component {
  state = {
    loading: false,
    loadingReport: false,
    loadingExport: false,
    currentWeek: true,
    row: null,
    from: null,
    to: null,
    showDetails: false,
    periods: [],
    grid: {
      data: [],
      headerDef: [],
      rowDef: [],
    },
    activeRow: {
      optionShowDetails: false,
    },
  };

  handleDownload = () => {
    const { from, currentWeek, periods, showDetails } = this.state;
    if (periods.length) {
      const to = currentWeek ? "-1" : this.state.to;
      const { siteId, operator } = this.props;

      this.setState({ loadingExport: true }, () => {
        this.fnGetExport(operator, siteId, from, to, showDetails).then(
          (response) => {
            this.setState({ loadingExport: false }, () => {
              handleDownload(response);
            });
          },
          () => this.setState({ loadingExport: false }),
        );
      });
    }
  };

  onDetailsClick = async () => {
    const { activeRow } = this.state;
    const { siteId, operator } = this.props;
    const { batchId } = activeRow;

    this.props.setCollectionModal({
      open: true,
      title: this.modalTitle,
      isPerformance: this.isPerformance,
      operator,
      siteId,
      batchId,
      fnLoad: this.fnRowClick,
    });
  };

  onRowClick = (activeRow) => this.setState({ activeRow });

  handleRefresh = () => {
    const { from, currentWeek, periods, showDetails } = this.state;
    if (periods.length) {
      const to = currentWeek ? "-1" : this.state.to;
      const { siteId, operator } = this.props;
      this.setState({ loading: true }, () => {
        this.fnRefresh(operator, siteId, from, to, showDetails).then(
          (result) => {
            this.setState({ loading: false, grid: result.grid }, () => {
              if (!this.state.grid.data.includes(this.state.activeRow))
                this.setState({ activeRow: { optionShowDetails: false } });
            });
          },
          () => this.setState({ loading: false }),
        );
      });
    }
  };

  componentDidMount() {
    this.loadPeriods();
  }

  loadPeriods = () => {
    const { siteId, operator } = this.props;
    this.setState(
      {
        loading: true,
        grid: {
          data: [],
          headerDef: [],
          rowDef: [],
        },
        periods: [],
      },
      () => {
        this.setState({ loading: false }, () => {
          if (siteId) {
            this.setState({ loading: true }, () => {
              collections.getPeriods(operator, siteId).then((periods) => {
                const defaultPeriod =
                  periods.find((period) => period.isDefault) || periods[0];
                this.setState(
                  {
                    periods,
                    from: defaultPeriod ? defaultPeriod.value : null,
                    loading: false,
                  },
                  () => {
                    if (periods.length > 0) this.handleRefresh();
                  },
                );
              });
            });
          }
        });
      },
    );
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.siteId !== prevProps.siteId ||
      this.props.operator !== prevProps.operator ||
      (!this.props.collectionModal.open && prevProps.collectionModal.open)
    ) {
      this.loadPeriods();
    }
  }

  setCurrentWeek = () =>
    this.setState({ currentWeek: !this.state.currentWeek });

  handleVarianceHistory = () => {
    this.props.showSiteVarianceHistoryModal(true);
  };

  onChange = (event, { name, value }) => this.setState({ [name]: value });

  handlePdfClick = (downloadFn = async () => {}) => {
    const { activeRow } = this.state;
    if (activeRow.batchId) {
      this.setState({ loadingReport: true }, () => {
        downloadFn(activeRow.batchId).then(
          (response) =>
            this.setState({ loadingReport: false }, () =>
              handleDownload(response),
            ),
          () => this.setState({ loadingReport: false }),
        );
      });
    }
  };

  handleCommentsClick = () => {
    const { activeRow } = this.state;
    if (!activeRow.batchId) {
      return;
    }

    this.setState({ loading: true }, () => {
      collections.getCommentsByBatchId(activeRow.batchId).then(
        (result) =>
          this.setState({ loading: false }, () =>
            this.props.showBankingCommentsModal(true, result),
          ),
        () => this.setState({ loading: false }),
      );
    });
  };

  render() {
    const { headerDef, rowDef, data } = this.state.grid;
    const { activeRow, loadingExport } = this.state;

    return (
      <Grid className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column width="8">
            <CollectionFilters
              {...this.state}
              onChange={this.onChange}
              onChangeCurrentWeek={this.setCurrentWeek}
              onVarianceClick={this.handleVarianceHistory}
              onRefreshClick={this.handleRefresh}
              onExportClick={this.handleDownload}
              loadingExport={loadingExport}
              showVarianceHistory={this.props.showVarianceHistory}
              isPerformance={this.isPerformance}
            />
          </Grid.Column>
          <Grid.Column textAlign="right" width="8">
            {activeRow.batchId && (
              <CommentsButton onClick={this.handleCommentsClick} />
            )}
            {activeRow.optionShowDetails && (
              <DetailsButton onClick={this.onDetailsClick} />
            )}
            {activeRow.batchId && this.fnGetSummaryPdf !== null && (
              <Dropdown
                direction="left"
                icon={null}
                floated="right"
                trigger={
                  <Button
                    color="teal"
                    loading={this.state.loadingReport}
                    icon
                    labelPosition="right"
                  >
                    <Icon name="caret down" /> Reports
                  </Button>
                }
              >
                <Dropdown.Menu>
                  <Dropdown.Item
                    text="Summary Report PDF"
                    onClick={() =>
                      this.handlePdfClick(this.fnGetSummaryReportPdf)
                    }
                  />
                  <Dropdown.Item
                    text={this.reportName}
                    onClick={() => this.handlePdfClick(this.fnGetSummaryPdf)}
                  />
                  {this.isPerformance && (
                    <Dropdown.Item
                      text={this.reportNameCsv}
                      onClick={() => this.handlePdfClick(this.fnGetSummaryCsv)}
                    />
                  )}
                  <Dropdown.Item
                    text="Collection Variance PDF"
                    onClick={() => this.handlePdfClick(this.fnGetVariancePdf)}
                  />
                </Dropdown.Menu>
              </Dropdown>
            )}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column width="16" className="gs-flex-container-vertical">
            <DataGrid
              loading={this.state.loading}
              headings={headerDef}
              data={data}
              activeRow={this.state.activeRow}
              rowDef={rowDef}
              onRowClick={this.onRowClick}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default BaseCollection;
